const friendlyHttpErrors = [400, 401, 403, 404, 409, 422, 503];

export default function isFriendlyHttpError(error: any) {
    return (
        typeof error === 'object' &&
        error.statusCode &&
        friendlyHttpErrors.includes(error.statusCode)
    );
}
